// extracted by mini-css-extract-plugin
export default {"productNativeCreativeDetailContainer":"productNativeCreativeDetail_productNativeCreativeDetailContainer__MKoOW"};